import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import type { BuilderProfileState } from '@/modules/__generated__/graphql/switchboard-generated';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import { useBuildersFiltersContext } from '../../../builders-filters/builders-filters-context';
import type SimpleBar from 'simplebar-react';
interface UseBuildersListProps {
  builders: BuilderProfileState[];
  asSectionContent?: boolean;
}
export function useBuildersList(t0) {
  const $ = _c(11);
  const {
    builders,
    asSectionContent: t1
  } = t0;
  const asSectionContent = t1 === undefined ? false : t1;
  const {
    isResetPending,
    isSkillsPending
  } = useBuildersFiltersContext();
  const simpleBarRef = useRef(null);
  const cardContentRef = useRef(null);
  const itemsWrapperRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      from: "sm",
      to: "md"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const isLargeMobile = useMediaQuery(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      from: "md"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isTablet = useMediaQuery(t3);
  let t4;
  let t5;
  if ($[2] !== asSectionContent || $[3] !== builders.length || $[4] !== isLargeMobile || $[5] !== isTablet) {
    t4 = () => {
      if (!asSectionContent) {
        return;
      }
      const simpleBarEl = simpleBarRef.current?.el;
      const cardContentEl = cardContentRef.current;
      const itemsWrapperEl = itemsWrapperRef.current;
      if (!simpleBarEl || !cardContentEl || !itemsWrapperEl) {
        return;
      }
      const teamsCount = builders.length;
      let config = null;
      if (isTablet) {
        config = {
          maxHeight: "722px",
          maxItems: 7
        };
      } else {
        if (isLargeMobile) {
          config = {
            maxHeight: "1058px",
            maxItems: 7
          };
        }
      }
      if (!config) {
        simpleBarEl.style.maxHeight = "";
        cardContentEl.style.paddingRight = "";
        return;
      }
      if (teamsCount > config.maxItems) {
        simpleBarEl.style.maxHeight = config.maxHeight;
        cardContentEl.style.paddingRight = "4px";
        itemsWrapperEl.style.paddingRight = "12px";
      }
    };
    t5 = [isTablet, isLargeMobile, builders.length, asSectionContent];
    $[2] = asSectionContent;
    $[3] = builders.length;
    $[4] = isLargeMobile;
    $[5] = isTablet;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== isResetPending || $[9] !== isSkillsPending) {
    t6 = {
      simpleBarRef,
      cardContentRef,
      itemsWrapperRef,
      isResetPending,
      isSkillsPending
    };
    $[8] = isResetPending;
    $[9] = isSkillsPending;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}